import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIProgress from 'UIComponents/progress/UIProgress';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getCurrentStepNumbering } from '../flow-management/stepNumberingSelectors';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getActiveError } from '../store/error/selectors';
import { getActiveLoading, getCanShowProgressBar } from '../store/loading-status/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { LORAX } from 'HubStyleTokens/colors';
const StyledProgressIndicator = styled.div.withConfig({
  displayName: "ProgressIndicator__StyledProgressIndicator",
  componentId: "sc-193rzmg-0"
})(["transition:all 0.6s ease-in-out;position:fixed;right:0;left:0;top:0;z-index:20;"]);
const ProgressIndicatorWrapper = styled.div.withConfig({
  displayName: "ProgressIndicator__ProgressIndicatorWrapper",
  componentId: "sc-193rzmg-1"
})(["height:8px;border-radius:0 3px 3px 0 !important;overflow:hidden;> *{margin:0;border-radius:0;}"]);
const ProgressIndicatorProgress = styled(UIProgress).withConfig({
  displayName: "ProgressIndicator__ProgressIndicatorProgress",
  componentId: "sc-193rzmg-2"
})(["appearance:none;height:8px;border-radius:0;[role='progressbar']{border-radius:0;background:", ";}"], LORAX);
export const ProgressIndicator = () => {
  const {
    currentStep,
    totalSteps
  } = useSelector(getCurrentStepNumbering);
  const {
    currentStep: currentStepName
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const loading = useSelector(getActiveLoading);
  const canShowProgressBar = useSelector(getCanShowProgressBar(loading));
  const stepConfig = getStepConfig(currentStepName);
  const shouldHalveProgressBar = getFlowConfig().shouldHalveProgressBar;
  let currentProgress = Math.round(currentStep / (totalSteps + 1) * 100);
  let shouldDisplay = !activeError && stepConfig && stepConfig.stepKey && !stepConfig.hideProgressBar;

  if (shouldHalveProgressBar) {
    currentProgress = currentProgress / 2;
  }

  if (loading && canShowProgressBar) {
    shouldDisplay = true;
  }

  return /*#__PURE__*/_jsx(StyledProgressIndicator, {
    style: {
      opacity: shouldDisplay ? 1 : 0
    },
    children: /*#__PURE__*/_jsx(ProgressIndicatorWrapper, {
      children: /*#__PURE__*/_jsx(ProgressIndicatorProgress, {
        "aria-label": `Step ${currentStep} of ${totalSteps}`,
        use: "warning",
        value: currentProgress
      })
    })
  });
};